import { Button, Stack, Table, Text, Tooltip } from "@mantine/core";
import { useSystemEmailPreviewHandler } from "../../../hooks/admin/useSystemEmailPreviewHandler";
import { useSystemEmailPreview } from "../../../hooks/admin/useSystemEmails";
import { SystemEmailPreviewThumbnail } from "./SystemEmailPreviewThumbnail";

interface Props {
  entryId: string;
  label: string;
  onPreview: (id: string) => void;
}

export function SystemEmailRegistryPreviewCell({
  entryId,
  label,
  onPreview,
}: Props) {
  const preview = useSystemEmailPreview(entryId);
  const handlePreview = useSystemEmailPreviewHandler(entryId, onPreview);
  return (
    <Table.Td w={180}>
      <Tooltip label="Expand email preview" offset={8} position="left">
        <Button
          aria-label={`Preview ${label}`}
          h={112}
          onClick={handlePreview}
          p={4}
          styles={{ label: { height: "100%", width: "100%" } }}
          variant="default"
          w={164}
        >
          <Stack gap={4} h="100%" w="100%">
            <SystemEmailPreviewThumbnail
              html={preview.data?.html}
              loading={preview.isLoading}
              subject={preview.data?.subject ?? label}
              unavailable={Boolean(preview.error)}
            />
            <Text fw={600} size="xs">
              Preview
            </Text>
          </Stack>
        </Button>
      </Tooltip>
    </Table.Td>
  );
}
